import { RECEIVE_ORDER } from './order';

const loadEmrData = emrData => ({
  type: RECEIVE_ORDER,
  order: emrData,
});

export { loadEmrData };
